import type { PersonId } from '@fs/zion-tree-types'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { useSwrRequest } from './useSwrRequest'

export type PrimaryParents = {
  preferred?: boolean
  parent1Id: PersonId
  parent2Id: PersonId
}

export default function usePrimaryParents(personId?: PersonId): PrimaryParents | undefined {
  const { currentTreeId } = useGroupsContext()
  const { data: parentsIds } = useSwrRequest<PrimaryParents[]>(
    personId ? `/service/tree/tree-data/v8/person/${personId}/parents-ids?treeId=${currentTreeId || 'PRIVATE'}` : null
  )

  if (!parentsIds) return undefined

  let preferredFamily = parentsIds.find(
    ({ preferred, parent1Id, parent2Id }) =>
      preferred && parent1Id && parent1Id !== 'UNKNOWN' && parent2Id && parent2Id !== 'UNKNOWN'
  )

  // If we don't have a preferred family that has both parents, then we'll just use the first one we find.
  if (!preferredFamily) {
    preferredFamily = parentsIds.find(
      ({ parent1Id, parent2Id }) => parent1Id && parent1Id !== 'UNKNOWN' && parent2Id && parent2Id !== 'UNKNOWN'
    )
  }

  return preferredFamily
}
